import conf from '../config/api.js';
import Vue from 'vue';
var moment = require('moment');
//var htmlEncode = require('js-htmlencode').htmlEncode;
var htmlDecode = require('js-htmlencode').htmlDecode;
import vuexStorage from '../store/index.js'

//Fonction génération de toaster erreur
function toasterError(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'error',
        position: 'bottom-right'
    })
}

//Fonction génération de toaster réussite
function toasterSuccess(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'success',
        position: 'bottom-right'
    })
}

//Fonction de chargement de la discussion du ticket client
async function expandTicketInfo(row){
	this.$refs.modalInfoTicket.show()
	this.modalInfoTicket.title=htmlDecode(row.subject);
	this.currentTicketRef=row.ref
	this.currentTrack= row.track_id
	try {
		var messages = await requestApi({method: 'GET', url: '/api/loadMessage/'+row.id, params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
		var files = await requestApi({method: 'GET', url: '/api/findFiles/'+row.ref, params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
		this.filesTicket = files
		this.messageInitial=htmlDecode(row.message);
		this.ticketMessages=messages
		for(var i=0;i<messages.length;i++){
			this.ticketMessages[i].message=htmlDecode(this.ticketMessages[i].message)
		}
		setTimeout(() => {
			var messages = document.getElementById("messages")
			messages.scrollTop = messages.scrollHeight
		}, "200")
	} catch (error) {
		if(error.response != undefined){
			toasterError(`Impossible de charger les messages du ticket`,'Chargement des messages')
			if(error.response.data.route!=null){
				this.$router.push(error.response.data.route);
			}
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
	}
}
  
//Fonction de chargement de la discussion du ticket admin
async function expandTicketInfoAdmin(row){
	this.currentTrack=row.track_id;
	this.titleCurrentTicket=row.ref;
	try {
		let messages = await requestApi({method: 'GET', url: '/api/loadMessage/'+row.id, params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
		document.getElementById("infoTicket").style.display="initial";
		this.messageInitial=htmlDecode(row.message);
		this.ticketMessages=messages
		for(var i=0;i<messages.length;i++){
			this.ticketMessages[i].message=htmlDecode(this.ticketMessages[i].message);
		}
	} catch (error) {
		if(error.response != undefined){
			toasterError(`Impossible de charger les messages du ticket`,'Chargement des messages')
			if(error.response.data.route!=null){
				this.$router.push(error.response.data.route);
			}
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
	}
}
  
//Filtrer les tickets
async function filterTickets(){
	var statut = this.selectedStatut;
	var severite = this.selectedSeverite;
	var type = this.selectedType;

	try {
		var tickets = await requestApi({method: 'GET', url: '/api/filterTickets', params: {type: type,severite: severite,statut: statut}, form: {}, headers: {'Content-Type': 'application/json'}})
		var statut = { "0": "Non lu","1": "Lu","2": "Assigné","3": "En cours","5": "En attente de retour","7": "En attente","8": "Cloturé"};
		this.tickets = tickets
		for(var i=0;i<this.tickets.length;i++){
			this.tickets[i].datec = moment(this.tickets[i].datec*1000).format("DD-MM-YYYY");
			this.tickets[i].fk_statut = statut[this.tickets[i].fk_statut];
		}
		this.totalRows=tickets.length;
	} catch (error) {
		console.log(error)
		if(error.response != undefined){
			toasterError(`Impossible de récupérer les contacts`,'Récupération des contacts ')
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
	}
}
  
//Filtrer les tickets client
async function filterTicketsClient(){
	var statut = this.selectedStatut;
	var severite = this.selectedSeverite;
	var type = this.selectedType;

	try {
		var tickets = await requestApi({method: 'GET', url: '/api/filterTicketsClient', params: {type: type,severite: severite,statut: statut}, form: {}, headers: {'Content-Type': 'application/json'}})
		var statut = { "0": "Non lu","1": "Lu","2": "Assigné","3": "En cours","5": "En attente de retour","7": "En attente","8": "Cloturé"};
		this.tickets = tickets
		for(var i=0;i<this.tickets.length;i++){
			this.tickets[i].datec = moment(this.tickets[i].datec*1000).format("DD-MM-YYYY");
			this.tickets[i].fk_statut = statut[this.tickets[i].fk_statut];
		}
		this.totalRows=tickets.length;
	} catch (error) {
		console.log(error)
		if(error.response != undefined){
			toasterError(`Impossible de récupérer les contacts`,'Récupération des contacts ')
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
	}
}

//Fonction chargement des sites de création de ticket admin
async function loadSites(){
	try {
		let sites = await requestApi({method: 'POST', url: '/api/loadingClient', params: {}, form: {sortfield: 't.nom'}, headers: {'Content-Type': 'application/json'}})
		this.clients = sites;
		for(var j=0; j<this.clients.length; j++){
			var tmp = {value:this.clients[j]["id"],text:this.clients[j]["name"]};
			this.optionsSites.push(tmp);
		}
	} catch (error) {
		if(error.response!= undefined){
			toasterError(`Chargement impossible`,'Chargement des sites')
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
	}
}

//Chargement du total des tickets
async function getTotalTickets(){
	try {
		let tickets = await requestApi({method: 'GET', url: '/api/getTotalTickets', params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
		this.totalRows = tickets
	} catch (error) {
		if(error.response != undefined){
			toasterError(`Impossible de charger les tickets support`,'Chargement des tickets')
			if(error.response.data.route!=null){
				this.$router.push(error.response.data.route);
			}
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
	}
}

//Chargement des tickets
async function loadTickets(page, limit){
	try {
		var allTickets = await requestApi({method: 'GET', url: '/api/loadTickets', params: {page: page, limit: limit}, form: {}, headers: {'Content-Type': 'application/json'}})
		var statut = { "0": "Non lu","1": "Lu","2": "Assigné","3": "En cours","5": "En attente de retour","7": "En attente","8": "Cloturé"};
		var type = { "COM": "Demande commerciale","DEMSAV": "Demande de SAV","ISSUE": "Demande technique","OTHER": "Autre"};
		this.tickets = allTickets
		for(var i=0;i<this.tickets.length;i++){
			this.tickets[i].datec = moment(this.tickets[i].datec*1000).format("DD-MM-YYYY");
			this.tickets[i].statut_label = statut[this.tickets[i].fk_statut];
			this.tickets[i].type_label = type[this.tickets[i].type_code];
		}
		this.totalRows=allTickets.length;
	} catch (error) {
		if(error.response != undefined){
			toasterError(`Impossible de charger les tickets support`,'Chargement des tickets')
			if(error.response.data.route!=null){
				this.$router.push(error.response.data.route);
			}
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
	}
}
  
//Chargement des tickets client
async function loadTicketsClient(that){
	if (!that) {
		that = this
	}
	try {
		var allTickets = await requestApi({method: 'GET', url: '/api/loadTicketsClient', params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
		var statut = { "0": "Non lu","1": "Lu","2": "Assigné","3": "En cours","5": "En attente de retour","7": "En attente","8": "Cloturé"};
		var type = { "COM": "Demande commerciale","DEMSAV": "Demande de SAV","ISSUE": "Demande technique","OTHER": "Autre"};
		that.tickets = allTickets
		for(var i=0;i<allTickets.length;i++){
			that.tickets[i].datec = moment(that.tickets[i].datec*1000).format("DD-MM-YYYY");
			that.tickets[i].statut_label = statut[that.tickets[i].fk_statut];
			that.tickets[i].type_label = type[that.tickets[i].type_code];
		}
		that.totalRows=allTickets.length;
	} catch (error) {
		if(error.response != undefined){
			toasterError(`Impossible de charger les tickets support`,'Chargement des tickets')
			if(error.response.data.route!=null){
				that.$router.push(error.response.data.route);
			}
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
	}
}

//Fonction pour masquer la discussion ticket
function masquerInfoTicket(){
	document.getElementById("infoTicket").style.display="none";
}

//Fonction d'envoi de message ticket client
async function sendMessage(){
	try {
		if(this.formDiscussion.messageTicket.length){
			let ticket = await requestApi({method: 'POST', url: '/api/sendMessage', params: {}, form: {trackId:this.currentTrack,message:this.formDiscussion.messageTicket}, headers: {'Content-Type': 'application/json'}})
			if(this.fileList.length){
				// var filesToUpload = new Array()
				const formData = new FormData()
				for(var i=0; i < this.fileList.length; i++){
					formData.append('myfile', this.fileList[i],this.fileList[i].name.replaceAll(" ","_"))
					// var tmp = {name:encodeURI(this.fileList[i].name.replaceAll(" ","_"))}
					// filesToUpload.push(tmp)
				}
				try {
					await requestApi({method: 'POST', url: '/api/uploadFilesTicket/'+ticket.ref, params: {}, form: formData, headers: {'Content-Type': 'multipart/form-data'}})
					this.fileList = []
					var files = await requestApi({method: 'GET', url: '/api/findFiles/'+ticket.ref, params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
					this.filesTicket = files
				} catch (error) {
					if(error.response != undefined){
						toasterError(`Impossible d'envoyer le ticket de support`,'Envoi de ticket')
					}else{
						toasterError(`Le service est momentanément indisponible`,'Service indisponible')
					}
				}
			}
			this.ticketMessages=ticket.messages;
			for(var i=0;i<ticket.messages.length;i++){
				this.ticketMessages[i].message=htmlDecode(this.ticketMessages[i].message);
			}
			setTimeout(() => {
				var messages = document.getElementById("messages")
				messages.scrollTop = messages.scrollHeight
			}, "200")
			this.formDiscussion.messageTicket="";
		}else{
			this.$message('Le message ne peut pas être vide.')
		}
	} catch (error) {
		if(error.response != undefined){
			toasterError(`Impossible d'envoyer le message sur le ticket`,'Envoi de message')
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
	}
}

//Fonction de création de ticket client
async function sendTicket(){
	try {
		if(this.form.messageTicket.length && this.form.sujet.length){
			let ticket = await requestApi({method: 'POST', url: '/api/sendTicket?nocache=' + new Date().getTime(), params: {}, form: this.form, headers: {'Content-Type': 'application/json'}})
			if(this.fileList.length){
				const formData = new FormData()
				for(var i=0; i < this.fileList.length; i++){
					formData.append('myfile', this.fileList[i],this.fileList[i].name.replaceAll(" ","_"))
				}
				try {
					await requestApi({method: 'POST', url: '/api/uploadFilesTicket/'+ticket.ref, params: {}, form: formData, headers: {'Content-Type': 'multipart/form-data'}})
					this.fileList = []
				} catch (error) {
					if(error.response != undefined){
						toasterError(`Impossible d'envoyer le ticket de support`,'Envoi de ticket')
					}else{
						toasterError(`Le service est momentanément indisponible`,'Service indisponible')
					}
				}
			}
			let dataLink = {
				idTicket: ticket.id, 
			}
			await requestApi({method: 'POST', url: '/api/linkContactToTicket?nocache=' + new Date().getTime(), params: {}, form:dataLink, headers: {'Content-Type': 'application/json'}})
			this.$root.$emit('bv::hide::modal', 'modalCreateTicket')
			await loadTicketsClient(this)
		}else{
			this.$message('Le ticket doit contenir un sujet et un message.')
		}
	} catch (error) {
		console.log(error)
		if(error.response != undefined){
			toasterError(`Impossible d'envoyer le ticket de support`,'Envoi de ticket')
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
	}
}

//Fonction de création de ticket admin
async function sendTicketAdmin(){
	try {
		let ticket = {
			selectedType:this.form.selectedType,
            selectedSite:this.form.selectedSite,
            messageTicket:this.form.messageTicket,
            sujet:this.form.sujet,
		}
		let idContact = 0
		let idTicket = 0
		if(this.form.selectedContact == "0"){
			let contact = {
				lastname:this.form.nomContact,
				firstname:this.form.prenomContact,
				socid:this.form.selectedSite,
				phone_pro:this.form.telephoneContact,
            	email:this.form.mailContact,
			}
			let resContact = await requestApi({method: 'POST', url: '/api/addContact?nocache=' + new Date().getTime(), params: {}, form:contact, headers: {'Content-Type': 'application/json'}})
			idContact = resContact.id
		}else{
			idContact = this.form.selectedContact
		}

		let resTicket = await requestApi({method: 'POST', url: '/api/sendTicketAdmin?nocache=' + new Date().getTime(), params: {}, form:ticket, headers: {'Content-Type': 'application/json'}})
		idTicket = resTicket.idTicket
		
		let dataLink = {
			idTicket: idTicket, 
			idContact: idContact
		}
		await requestApi({method: 'POST', url: '/api/linkContactToTicket?nocache=' + new Date().getTime(), params: {}, form:dataLink, headers: {'Content-Type': 'application/json'}})
		toasterSuccess(`Le ticket a été créé avec succès`,'Création de ticket')
	} catch (error) {
		console.log(error)
		if(error.response != undefined){
			toasterError(`Impossible d'envoyer le ticket de support`,'Envoi de ticket')
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
	}
}

//Fonction de récupération des contacts pour assignation des ticket
async function searchContact(idTier){
	try {
		return await requestApi({method: 'GET', url: '/api/loadingContacts?nocache=' + new Date().getTime(), params: {id: idTier}, form: {}, headers: {'Content-Type': 'application/json'}})
	} catch (error) {
		console.log(error)
		if(error.response != undefined){
			toasterError(`Impossible de récupérer les contacts`,'Récupération des contacts ')
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
	}
}

//Fonction de récupération des contacts
async function getContacts (){
	try {
		let contacts = await requestApi({method: 'GET', url: '/api/loadingContacts?nocache=' + new Date().getTime(), params: {id: idTier}, form: {}, headers: {'Content-Type': 'application/json'}})
		this.formContrat.siege.contact = contacts[0].firstname + ' ' + contacts[0].lastname
		this.formContrat.siege.fonction = contacts[0].poste
		this.formContrat.siege.courriel = contacts[0].mail
		if(contacts[0].phone_mobile){
			this.formContrat.siege.telephone = contacts[0].phone_mobile
		}else if(contacts[0].phone_perso){
			this.formContrat.siege.telephone = contacts[0].phone_perso
		}else{
			this.formContrat.siege.telephone = contacts[0].phone_pro
		}
	} catch (error) {
		if(error.response != undefined){
			toasterError(`Impossible de récupérer les contacts`,'Récupération des contacts ')
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
	}
}

//Fonction pour télécharger un fichier joint d'un ticket
async function downloadFileTicket(ref, name){
	try {
		var element = document.createElement('a')
		element.setAttribute('href', '/api/downloadFileTicket/'+ref+'/'+name)
		element.style.display = 'none'
		document.body.appendChild(element)
		element.click()
		document.body.removeChild(element)
	} catch (error) {
		if(error.response != undefined){
			toasterError(`Téléchargement impossible`,'Récupération du fichier')
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
	}
	
}

// Fonction appel api
/*
  args: options : method -- required
                  url -- required
                  params -- optional -- url parameters
                  form -- optional -- request body applicable only with PUT, POST and Patch methods
                  headers -- optional
*/
function requestApi (options) {
	return new Promise((resolve, reject) => {
		new Vue().axios({
			method: options.method,
			url: conf.server + options.url,
			params: options.params,
			data: options.form,
			headers: options.headers,
			withCredentials: true
		}).then((response) => {
			resolve(response.data)
		}).catch((error) => {
			reject(error)
		})
	})
}

export default{
	expandTicketInfoAdmin,
	expandTicketInfo,
	filterTicketsClient,
	filterTickets,
	loadTickets,
	masquerInfoTicket,
	loadTicketsClient,
	loadSites,
	sendMessage,
	sendTicketAdmin,
	sendTicket,
	getTotalTickets,
	toasterError,
  	toasterSuccess,
	  getContacts,
	  searchContact,
	  downloadFileTicket,
}

